import { jsx as _jsx } from "react/jsx-runtime";
import { LoaderCircle } from 'lucide-react';
import { cn } from '../../lib/utils';
export const LocalLoader = (param)=>{
    let { className } = param;
    return /*#__PURE__*/ _jsx(LoaderCircle, {
        className: cn('animate-spin text-purple-500', className)
    });
};
